import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { CellContext } from '@tanstack/react-table';

export interface ChargePointListIsOnlineCellProps
  extends CellContext<GatewayChargePointModel, unknown> {}

export const ChargePointListIsOnlineCell = (
  props: ChargePointListIsOnlineCellProps,
): React.JSX.Element | null => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return row.original.isOnline ? null : <Icon name="wifi-off" />;
};
